<template>
    <ImportPricePlansForm
        submit-route="products.products.plans.import.submit"
        cancel-route-name="products.products.download-upload"
        :errors="errors"
    />
</template>

<script setup>
import ImportPricePlansForm from '~@/Components/Products/Products/ImportPricePlansForm.vue'

defineProps({
    errors: { type: Object, default: () => ({}) },
})
</script>
